import dayjs from "dayjs";
import { Timestamp, timestampToDate } from "api/firebase";
import { isToday, isYesterday } from "tools/formats/dayJsFormat/helpers";
import { ShowDateFormat } from "@evennt-tech/api-v2-core";

const formatDate = (
  date: Date | number | string,
  pattern: string = ShowDateFormat.dayFirst.toUpperCase()
) => dayjs(date).format(pattern);

export const formatTimestamp = (
  timestamp: Timestamp,
  pattern = "D MMM YYYY, HH:mm"
) => {
  const date = timestampToDate(timestamp.seconds, timestamp.nanoseconds);
  return dayjs(date).format(pattern);
};

export const formatCreatedAt = (isoTimestamp: string, pattern: string) => {
  const date = new Date(isoTimestamp);
  if (isToday(date)) {
    return `Today, ${formatDate(date, "HH:mm")}`;
  }
  if (isYesterday(date)) {
    return `Yesterday, ${formatDate(date, "HH:mm")}`;
  }
  return formatDate(date, pattern);
};

export default formatDate;
